import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Layout, Space, Timeline, DatePicker } from 'antd';
import style from './style.scss';
import { TM_FRAUD_SOURCE_IDS } from '../../../../util/GlobalConstant';
import FlagRed from '../../../../assets/flag_Red.svg';
import FlagOrange from '../../../../assets/flag_Orange.svg';

const { Content } = Layout;
const { RangePicker } = DatePicker;

function disabledDate(current) {
  // Can not select days after current date
  return current && current > moment().endOf('day');
}

const DataSet = ({
  onChange,
  trainingDays,
  predictionDays,
  scenarioSource
}) => {
  const onTrainingDateChange = useCallback((item) => {
    item[0].startOf('day');
    item[1].endOf('day');
    const value = item
      ? { item, days: item[1].diff(item[0], 'days') + 1 }
      : null;
    onChange?.({ trainingDates: value });
  });
  const onPredictionDateChange = useCallback((item) => {
    item[0].startOf('day');
    item[1].endOf('day');
    const value = item
      ? { item, days: item[1].diff(item[0], 'days') + 1 }
      : null;
    onChange?.({ predictionDates: value });
  });

  const getNumberDayString = useCallback((days) => {
    const day_s = days === 1 ? '' : 's';
    return days !== Infinity ? `${days} Day${day_s}` : '';
  });

  return (
    <Content>
      <Space direction="vertical" className={style.tabPanelSpace}>
        <Content className={style.site_layout_background}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}>
            <p style={{ fontWeight: '500' }}>
              {scenarioSource === TM_FRAUD_SOURCE_IDS.TM && (
                <span style={{ paddingLeft: '5px' }}>
                  <img src={FlagOrange} alt="" /> AML-TM Detection
                </span>
              )}
              {scenarioSource === TM_FRAUD_SOURCE_IDS.FRAUD && (
                <span style={{ paddingLeft: '5px' }}>
                  <img src={FlagRed} alt="" /> Fraud Detection
                </span>
              )}
              {scenarioSource === TM_FRAUD_SOURCE_IDS.FRAUD_PREVENTION_ID && (
                <span style={{ paddingLeft: '5px' }}>
                  <img src={FlagRed} alt="" /> Fraud Prevention
                </span>
              )}
            </p>
            <Timeline>
              <Timeline.Item>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ marginRight: 27 }}>Training</div>
                  <div style={{ marginRight: 24 }}>
                    <RangePicker
                      allowClear={true}
                      autoFocus={true}
                      bordered={true}
                      disabledDate={disabledDate}
                      onChange={onTrainingDateChange}
                    />
                  </div>
                  <div>{getNumberDayString(trainingDays || Infinity)}</div>
                </div>
              </Timeline.Item>
              <Timeline.Item>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      marginRight: 12,
                      alignItems: 'center'
                    }}>
                    Prediction
                  </div>
                  <div style={{ marginRight: 24 }}>
                    <RangePicker
                      allowClear={true}
                      bordered={true}
                      disabledDate={disabledDate}
                      onChange={onPredictionDateChange}
                    />
                  </div>
                  <div>{getNumberDayString(predictionDays || Infinity)}</div>
                </div>
              </Timeline.Item>
            </Timeline>
          </div>
        </Content>
      </Space>
    </Content>
  );
};

DataSet.propTypes = {
  onChange: PropTypes.func,
  trainingDays: PropTypes.number,
  predictionDays: PropTypes.number
};

export default DataSet;
